<template>
  <div id="userMessage">
    <van-nav-bar
      :fixed="true"
      left-arrow
      @click-left="handlerStep(-1)"
      @click-right="goNext()"
      :right-text="setpList[step + 1]"
    >
      <template slot="title">
        <span class="title">客户录入</span>
        <span class="subtitle">-{{ setpList[step] }}</span>
      </template>
    </van-nav-bar>

    <van-form @submit="onSubmit" name="userinfo" ref="userinfo">
      <baseinfo
        v-if="step == 0"
        :useMessage="useMessage"
        @telerror="onTelerror"
      ></baseinfo>
      <appendfaq
        v-if="step == 1"
        :appendinfo="useMessage.调查问卷"
        :questionnaire="questionnaire"
        :append="questres"
      ></appendfaq>

      <div style="margin: 16px">
        <van-row>
          <van-col span="12"
            ><van-button
              v-if="step > 0"
              round
              block
              @click.prevent="handlerStep(-1)"
              >上一步</van-button
            >
            <van-button v-else round block @click.prevent="$router.back()"
              >取消</van-button
            >
          </van-col>

          <van-col span="12">
            <van-button
              v-if="step == setpList.length - 1"
              round
              block
              type="info"
              native-type="submit"
              >提交</van-button
            >
            <van-button
              v-else
              round
              block
              native-type="submit"
             
              >下一步</van-button
            >
          </van-col>
        </van-row>
      </div>
    </van-form>
  </div>
</template>
<script>
import appendfaq from "./appendinfo";
import baseinfo from "./baseinfo";

export default {
  name: "userMessage",
  props: { useMessage: Object },
  components: { appendfaq, baseinfo },
  data() {
    return {
      setpList: ["基本信息", "补充问卷"],
      step: 0,
    
      questionnaire: [],
      questres: {},
      projectname: "",
      // useMessage: {
      //   所属项目: localStorage.getItem("projectname"),
      //   客户姓名: "",
      //   性别: "",
      //   客户电话: "",
      //   客户地区: "",
      //   详细地址: "",
      // },
    };
  },
  created() {
    this.getQuestionnaire();

    // this.projectname = localStorage.getItem("projectname");
    // if (this.projectname == "") {
    //   alert("请选择项目");
    // }
    // this.id = this.$route.params.id;
    // if (this.id != "new") {
    //   // this.$nextTick(() => {
    //   this.$request.customerDetial({ _id: this.id }).then((res) => {
    //     if (res.code == 0) {
    //       this.useMessage = res.data;
          
    //     }
    //   });
    //   // });
    // } else {
    //   this.getQuestionnaire();
    // }
  },

  methods: {
    onTelerror(val) {
      this.telerror = val;
    },
    goNext() {
      this.$refs["userinfo"].submit();
    },

    handlerStep(v) {
      var step = this.step + v;
      if (this.setpList.length == step) {
        step = this.setpList.length - 1;
        return true;
      }
      if (step < 0) {
        this.$router.back();
      }

      this.step = step;
      return false;
    },
    onSave() {
      this.$refs["userinfo"].submit();
    },
    //提交信息
    onSubmit(values) {
      if (this.handlerStep(1) == false) {
        return;
      }
     
      this.useMessage.完整地址 = `${this.useMessage.客户地区}-${this.useMessage.详细地址}`;
      this.fullReqs();

      this.$request.customerSave(this.useMessage).then((res) => {
        if (res.code == 0) {
          this.$toast({
            message: "保存成功",
          });
          this.$router.back();
        } else {
          this.$toast({
            message: res.msg,
          });
        }
      });

      // this.restUseMessge();
    },

    getQuestionnaire() {
      let req = {
        table_name: "sys_questionnaire",
        req: { 所属项目: "新基业当代阅ΜΟΜΛ" },
        sort: "order",
      };
      this.$request.dbreq(req).then((res) => {
        this.$set(this, "questionnaire", res.data.items);
        this.questionnaire = res.data.items;

        if (this.useMessage.调查问卷 == undefined) {
          this.useMessage.调查问卷 = [];
          for (var i in this.questionnaire) {
            let q = this.questionnaire[i];
            this.useMessage.调查问卷[i] = {
              title: q.title,
            };
          }
        }

        // appendinfo
      });
    },
    fullReqs() {
      for (var i in this.questionnaire) {
        let title = this.questionnaire[i].title;
        let flag = true;
        for (var j in this.useMessage.调查问卷) {
          if (this.useMessage.调查问卷[j].title == title) {
            flag = false;
          }
        }
        if (flag) this.useMessage.调查问卷.push({ title: title });
      }

      for (var i in this.useMessage.调查问卷) {
        let title = this.useMessage.调查问卷[i].title;
        this.useMessage.调查问卷[i].value = this.questres[title].value;
      }

      this.useMessage["问卷日期"] = Date.parse(new Date()).toString();
    },

    
  },
};
</script>
<style scoped lang="less">
#userMessage {
  box-sizing: border-box;
  padding: 10px;
  padding-top: 48px;
  background: #fff;
}
.title {
  font-size: 12px;
}
.van-button {
  margin: 0 10px;
}
.subtitle {
  font-size: 10px;

  color: cadetblue;
}
</style>